/** Lets the browser paint (e.g. streaming / “Thinking…” UI) before more JS runs. */
export function yieldToMain(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });
}

/** Cooperative yield when the scheduler API exists (Chrome 129+). */
export async function yieldScheduler(): Promise<void> {
  const sched = (globalThis as { scheduler?: { yield?: () => Promise<void> } }).scheduler;
  if (sched?.yield) {
    await sched.yield();
    return;
  }
  await new Promise<void>((r) => setTimeout(r, 0));
}
